<template>
  <div class="input">
    <IconLoading />
  </div>
</template>

<script setup lang="ts">
import IconLoading from '../../svg/IconLoading.vue';
</script>

<style lang="scss" scoped>
.input {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
